import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Transition as _Transition, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-213b6c0a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "section-card" }
const _hoisted_2 = { class: "custom-card-title title-card foldable-section-title" }
const _hoisted_3 = ["aria-expanded"]
const _hoisted_4 = { class: "foldable-section-title-content" }
const _hoisted_5 = {
  key: 0,
  class: "foldable-section-count"
}
const _hoisted_6 = {
  class: "icon is-small foldable-section-icon",
  "aria-hidden": "true"
}
const _hoisted_7 = {
  key: 0,
  class: "foldable-section-body"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_fa_icon = _resolveComponent("fa-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, [
      _createElementVNode("button", {
        class: "foldable-section-toggle",
        type: "button",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isSectionOpen = !_ctx.isSectionOpen)),
        "aria-expanded": _ctx.isSectionOpen
      }, [
        _createElementVNode("span", _hoisted_4, [
          _renderSlot(_ctx.$slots, "title", {}, () => [
            _createTextVNode(_toDisplayString(_ctx.title), 1)
          ]),
          (_ctx.shouldShowCount)
            ? (_openBlock(), _createElementBlock("span", _hoisted_5, " (" + _toDisplayString(_ctx.count) + ") ", 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("span", _hoisted_6, [
          _createVNode(_component_fa_icon, {
            icon: _ctx.isSectionOpen ? 'chevron-up' : 'chevron-down'
          }, null, 8, ["icon"])
        ])
      ], 8, _hoisted_3)
    ]),
    _createVNode(_Transition, { name: "foldable-section" }, {
      default: _withCtx(() => [
        (_ctx.shouldShowBody)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _renderSlot(_ctx.$slots, "default")
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 3
    })
  ]))
}